import { Link } from "react-router-dom";
import { BrandLockup } from "./LogoMark";
import { SUPPORT_EMAIL } from "@/lib/site";

const PRODUCT = [
  { label: "Features", href: "#features", testid: "footer-link-features" },
  { label: "How it works", href: "#how", testid: "footer-link-how" },
  { label: "Safety", href: "#safety", testid: "footer-link-safety" },
  { label: "Download", href: "#download", testid: "footer-link-download" },
];

const LEGAL = [
  { label: "Privacy Policy", to: "/privacy", testid: "footer-link-privacy" },
  { label: "Terms of Use (EULA)", to: "/terms", testid: "footer-link-terms" },
  { label: "Community Guidelines", to: "/guidelines", testid: "footer-link-guidelines" },
  { label: "Dating Safety Tips", to: "/safety", testid: "footer-link-safety-tips" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-hairline bg-sand">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
        <div className="col-span-2 md:col-span-1">
          <BrandLockup />
          <p className="mt-4 max-w-[240px] text-sm leading-relaxed text-clay">
            Dating for healthcare professionals. Off call for work, on call for
            love.
          </p>
        </div>
        <div>
          <h4 className="text-xs font-extrabold uppercase tracking-[0.18em] text-clay">Product</h4>
          <div className="mt-4 flex flex-col gap-2.5">
            {PRODUCT.map((l) => (
              <a key={l.label} href={l.href} data-testid={l.testid} className="text-sm font-semibold text-ink/80 transition-colors hover:text-terracotta">
                {l.label}
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs font-extrabold uppercase tracking-[0.18em] text-clay">Legal</h4>
          <div className="mt-4 flex flex-col gap-2.5">
            {LEGAL.map((l) => (
              <Link key={l.label} to={l.to} data-testid={l.testid} className="text-sm font-semibold text-ink/80 transition-colors hover:text-terracotta">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs font-extrabold uppercase tracking-[0.18em] text-clay">Support</h4>
          <div className="mt-4 flex flex-col gap-2.5">
            <Link to="/support" data-testid="footer-link-support" className="text-sm font-semibold text-ink/80 transition-colors hover:text-terracotta">
              Support & Contact
            </Link>
            <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="footer-mailto-support" className="text-sm font-semibold text-ink/80 transition-colors hover:text-terracotta">
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 border-t border-hairline pt-8 text-[13px] leading-relaxed text-clay">
        <span className="mb-4 inline-flex items-center gap-2 rounded-lg bg-peach/70 px-3 py-1.5 text-xs font-extrabold text-terracotta-dark">
          18+ · STETH is intended for adults only
        </span>
        <p>
          STETH is a dating and social-connection app for healthcare
          professionals. By creating an account you agree to our{" "}
          <Link to="/terms" className="font-bold text-terracotta">Terms of Use (EULA)</Link> and{" "}
          <Link to="/privacy" className="font-bold text-terracotta">Privacy Policy</Link>, and confirm you have
          read our <Link to="/guidelines" className="font-bold text-terracotta">Community Guidelines</Link>.
          STETH has a zero-tolerance policy for objectionable content and abusive
          behavior; we review all reports and act on violations typically within
          24 hours. STETH does not provide medical advice, clinical
          communication, or healthcare services. "Verified Healthcare Pro"
          status reflects user-submitted information and does not constitute a
          professional endorsement or guarantee of credentials. Please review
          our <Link to="/safety" className="font-bold text-terracotta">Dating Safety Tips</Link>.
        </p>
        <p className="mt-4">
          Apple and the Apple logo are trademarks of Apple Inc. © 2026 Wingwomen
          Inc. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
